import React, { Component, PropTypes } from 'react';
import Relay from 'react-relay';
import styler from 'react-styling';
import { StyleRoot } from 'radium';
import ContactsContainer from './ContactsContainer';
import NavbarTop from '../Components/NavbarTop';
import NavSideLeftSmall from '../Components/NavSideLeftSmall';
import getLanguage from '../libs/Languages';
import { clearLocalStorageOnWindowUnload } from '../libs/LocalStorage';
import breakpoints from '../../css/breakpoints';

const style = styler `
  Navtop
    visibility: hidden
    @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
      visibility: visible
`;


class App extends Component {
  render() {
    clearLocalStorageOnWindowUnload('scheduler');
    const messages = getLanguage();
    return (
      <StyleRoot>
        <div>
          <div className={'navbar-top-1'} style={style.Navtop}>
            <NavbarTop
              languagedata={messages}
              me={this.props.viewer.me}
            />
          </div>
          <div className={'nav-side-left-1 hidden-xs hidden-sm'}>
            <NavSideLeftSmall
              languagedata={messages}
              me={this.props.viewer.me}
            />
          </div>
          <div id="content">
            {this.props.children}
          </div>
        </div>
      </StyleRoot>
    );
  }
}

export default Relay.createContainer(App, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        me {
          email
          displayName
        }
        ${ContactsContainer.getFragment('viewer')}
      }
    `,
  },
});

App.propTypes = {
  viewer: PropTypes.any,
  children: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Containers/App.js